<!--
 * @Author: wangliang
 * @LastEditTime: 2024-03-12 10:28:33
 * @Description: 模型库树
-->
<template>
  <div>
    <el-dialog
      class="mini-dialog"
      v-dialogDrag
      :append-to-body="true"
      :visible.sync="modelTreeProps.visible"
      :title="modelTreeProps.title"
      :close-on-click-modal="false"
      @close="close(false)"
    >
      <el-form
        :model="modelTreeContextForm"
        :rules="modelTreeFormRules"
        ref="modelTreeForm"
        label-width="150px"
        :disabled="modelTreeProps.editType === 'read'"
      >
        <el-form-item :label="`${pageTitle}库名称`" prop="name">
          <el-input
            v-model="modelTreeContextForm.name"
            :type="modelTreeProps.editType === 'create' ? 'textarea' : 'text'"
            :nums="3"
            :autosize="{ minRows: 3, maxRows: 10 }"
            :placeholder="`请输入${pageTitle}名称`"
            size="small"
            clearable
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex justify-center" v-if="modelTreeProps.editType !== 'read'">
        <el-button
          size="small"
          type="primary"
          @click="save()"
          :loading="saveLoading"
          >保存</el-button
        >
        <el-button size="small" @click="close(false)">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { AnimationDirectoryApi, ModelDirectoryApi } from '@wiz-api/material-management'
import {
  TheEngineeringModelSceneTreeApi,
} from '@wiz-api/cloud-render-management'
import { pickBy, get, filter, map, split, cloneDeep } from 'lodash'

// 动效管理时替换 api为animationApi
const modelDirectoryApi = new ModelDirectoryApi()
const animationDirectoryApi = new AnimationDirectoryApi()
const theEngineeringModelSceneTreeApi = new TheEngineeringModelSceneTreeApi()

export default {
  name: 'operateModelTreeDialog',
  props: {
    modelTreeProps: {
      type: Object,
      default: () => {
        return {
          visible: true,
          title: '新增模型库',
          editType: 'create',
        }
      },
    },
    modelTreeForm: {
      type: Object,
      default: () => {
        return {
          name: '',
        }
      },
    },
    // 弹框信息 默认为模型库
    pageInfo: {
      type: Object,
      default: () => {
        return {
          pageTitle: '模型',
          materialType: 1,
        }
      },
    },
  },
  data() {
    return {
      modelTreeContextForm: {
        name: '',
      },
      // 表单保存状态
      saveLoading: false,
      // 请求实例
      requestInstance: null,
    }
  },
  computed: {
    pageTitle() {
      return get(this.pageInfo, 'pageTitle')
    },
    modelTreeFormRules() {
      return {
        name: [
          {
            required: true,
            message: `请输入${this.pageTitle}库名称`,
            trigger: 'blur',
          },
        ],
      }
    },
  },
  methods: {
    close(expandId) {
      this.$emit('closeModelTreeDialog', expandId)
    },
    save() {
      this.$refs.modelTreeForm.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          if (this.modelTreeProps.editType === 'create') {
            // 过滤空字段
            const bodyItem = pickBy(
              {
                parentId: get(this.modelTreeContextForm, 'id') || '',
              },
              Boolean
            )
            // 批量添加模型库目录
            const body = map(
              filter(split(get(this.modelTreeContextForm, ['name']), '\n'), Boolean),
              (name) => {
                return {
                  ...bodyItem,
                  name,
                }
              }
            )
            const [err] = await this.requestInstance.insertMany({
              body,
            })
            this.saveLoading = false
            if (!err) {
              this.$message.success('新增成功')
              this.close(get(this.modelTreeContextForm, 'id') || '')
            }
            return
          }
          const [err] = await this.requestInstance.update(this.modelTreeContextForm.id, {
            body: this.modelTreeContextForm,
          })
          this.saveLoading = false
          if (!err) {
            this.$message.success('修改成功')
            this.close(this.parentId || '')
          }
        }
      })
    },
  },
  created() {
    const { materialType } = this.$route.meta
    switch (materialType) {
      // 动效管理时替换 api为animationApi
      case 1:
        this.requestInstance = modelDirectoryApi
        break
      case 2:
        this.requestInstance = animationDirectoryApi
        break
      case 3:
        this.requestInstance = theEngineeringModelSceneTreeApi
        break
      default:
        break
    }
    this.modelTreeContextForm = cloneDeep(this.modelTreeForm)
  },
}
</script>
